<template>
  <div id="EditTypeName" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回活動類型列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
        <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>活動類型:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData[0].typeName"
                  ref="inputData[0].typeName"
                  placeholder="請輸入活動類型"
                />
              </div>
            </td>
          </tr>



        </tbody>
      </table>
    </div>

        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="EditTypeName()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>

  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "EditTypeName",
  props: ["sn"],

  data() {
    return {
      RowId:"",
      AttachContent:[],
      mode: false,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      total: 0,
      isIE: false,
      getTeacherData: null,
       inputData: [{
        sn:0,
        typeName:null,
           }],
      currentPage: 1,

      pageSize: 10,

    };
  },
  computed: {
  user () {
   return this.$store.getters.getUser
   },

  },
  methods: {

    hideModal(name) {
      this.$refs[name].hide();

    },

    checkInput() {
   this.inputFlag = false;
      if (tools.empty(this.inputData[0].typeName)) {
        alert("請輸入活動類型");

        this.inputFlag = true;
        return;
      }



    },

    EditTypeName() {
      this.checkInput();
       let vm = this;


      if (this.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/EditTypeName/", this.inputData[0])
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "更新活動類型成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,更新活動類型失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },

    close() {
      this.$emit("hideModal");
    },

  },
  created() {
    console.log("======created EditTypeNameView =====");

    let vm = this;

    vm.inputData[0].sn = this.$props.sn;
    this.$http
      .get("../WebApi/HighSchoolEnrolling/GetTypeNameDetail/".concat(vm.inputData[0].sn))
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data;
        }
      })
      .catch(function (error) {
        alert("網路連線失敗" + error);

      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
